import { ACCOUNT } from "app/shared/services/services-model.type";
import CrcModule from "crc";

const payloadFormatIndicator = {
  id: "00",
  length: "02",
  value: "01",
};
const pointOfInitiationMethod = {
  id: "01",
  length: "02",
  value: "",
};
const consumerAccountInfo = {
  id: "38",
  length: "",
  value: "", // payloadNapas + consumer info + serviceCode
};
const payloadNapas = {
  id: "00",
  length: "10",
  value: "A000000727",
};
const consumerInfo = {
  id: "01",
  length: "",
  value: "", // payloadBank + accountInformation
};
const payloadBank = {
  id: "00",
  length: "06",
  value: "970412",
};
const accountInformation = {
  id: "01",
  length: "",
  value: "",
};
const serviceCode = {
  id: "02",
  length: "08",
  value: "QRIBFTTA",
};
const currencyCode = {
  id: "53",
  length: "03",
  value: "704", // VND
};
const countryCode = {
  id: "58",
  length: "02",
  value: "VN",
};
const crc = {
  id: "63",
  length: "04",
  value: "",
};

const createStringForAccountInformation = () => {
  accountInformation.length = String(accountInformation.value.length).padStart(2, "0");
  const strAccountInformation = convertObjectToString(accountInformation);
  const strPayloadBank = convertObjectToString(payloadBank);
  consumerInfo.value = strPayloadBank + strAccountInformation;
  consumerInfo.length = String(consumerInfo.value.length).padStart(2, "0");
  const strConsumerInfo = convertObjectToString(consumerInfo);

  // create object for service code
  // serviceCode.value = accountType;
  const strServiceCode = convertObjectToString(serviceCode);
  const strPayloadNapas = convertObjectToString(payloadNapas);

  // create object Consumer Account Information
  consumerAccountInfo.value = strPayloadNapas + strConsumerInfo + strServiceCode;
  consumerAccountInfo.length = String(consumerAccountInfo.value.length).padStart(2, "0");
};

const createStringForAdditionData = () => {
  pointOfInitiationMethod.value = "11";
};

const createFinalString = () => {
  const strFinalPayloadFormatIndicator = convertObjectToString(payloadFormatIndicator);
  const strPointOfInitiationMethod = convertObjectToString(pointOfInitiationMethod);
  const strTransactionCurrency = convertObjectToString(currencyCode);
  const strCountryCode = convertObjectToString(countryCode);
  const strCrc = convertObjectToString(crc);

  const strConsumerAccountInfo = convertObjectToString(consumerAccountInfo);
  return (
    strFinalPayloadFormatIndicator + strPointOfInitiationMethod + strConsumerAccountInfo + strTransactionCurrency + strCountryCode + strCrc
  );
};

const createStringForQR = (account: ACCOUNT | undefined) => {
  accountInformation.value = account?.ACCOUNTNO || "";
  createStringForAccountInformation();
  createStringForAdditionData();
  const finalString = createFinalString();
  const checkSum = CrcModule.crc16ccitt(finalString).toString(16).toUpperCase();
  return finalString + checkSum;
};

const convertObjectToString = (obj: any) => {
  if (obj.length === "") {
    return "";
  } else {
    const objArray = Object.values(obj).toString();
    if (typeof objArray === "string") {
      return objArray.replace(/,/g, "");
    }
  }
  return "";
};

const CustomQRCreatorUtils = {
  createFinalString,
  createStringForQR,
};

export default CustomQRCreatorUtils;
